import { EmploymentStatus } from "@modules/client/types";
import { forwardRef, ReactNode } from "react";
import { FieldError } from "react-hook-form";
import { startCase, capitalize } from "lodash";
import InputLabel from "../InputLabel";
import { SelectBox } from "@earned/core";

interface EmploymentStatusSelectProps {
  value: string | null | undefined;
  required?: boolean;
  error?: FieldError;
  label?: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void;
}

const EmploymentStatusSelect = forwardRef<
  HTMLDivElement,
  EmploymentStatusSelectProps
>(({ required, error, label, onChange, value, ...rest }, ref) => {
  const options = [
    {
      id: "",
      value: null,
      label: "",
    },
    ...Object.keys(EmploymentStatus).map((employmentStatus) => {
      return {
        id: employmentStatus,
        value:
          EmploymentStatus[employmentStatus as keyof typeof EmploymentStatus],
        label: capitalize(startCase(employmentStatus)),
      };
    }),
  ];
  return (
    <div className={`relative flex flex-col`}>
      {!!label && <InputLabel required={required} value={label} />}
      <SelectBox
        ref={ref}
        selected={options?.find((o) => o.value === value) ?? options[0]}
        options={options}
        required={required}
        error={error?.message}
        onChange={(opt) => onChange(opt.value)}
        {...rest}
      />
    </div>
  );
});

EmploymentStatusSelect.displayName = "EmploymentStatusSelect";

export default EmploymentStatusSelect;
